<!-- 发票提取单据 -->
<template>
    <div>
        <el-form v-if="formShow" :inline="true" label-width="100px" :model="invoiceExtractData" class="demo-form-inline dis" size="mini">
            <el-row>
                <el-form-item label="货主名称">
                    <label slot="label" :style="$common.labelStyle('货主名称')" v-html="'货主名称'"></label>
                    <el-input clearable v-model="invoiceExtractData.coName" class="form_codition" @keyup.enter.native="openSearch('4414428383875072', 0, 'coName','coId,coName')">
                        <el-button @click="openSearch('4414428383875072', 0, 'coName','coId,coName')" slot="append" icon="el-icon-search"></el-button>
                    </el-input>
                </el-form-item>
                <el-form-item label="业务单号">
                    <label slot="label" :style="$common.labelStyle('业务单号')" v-html="'业务单号'"></label>
                    <el-input clearable v-model="invoiceExtractData.businessId" class="form_codition"></el-input>
                </el-form-item>
                <el-form-item label="通用名称">
                    <label slot="label" :style="$common.labelStyle('通用名称')" v-html="'通用名称'"></label>
                    <el-input clearable v-model="invoiceExtractData.bgmName" class="form_codition"></el-input>
                </el-form-item>
                <el-form-item label="总金额">
                    <label slot="label" :style="$common.labelStyle('总金额')" v-html="'总金额'"></label>
                    <el-input clearable type="number" v-model="invoiceExtractData.totalMoney" class="form_codition"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button size="mini" @click="getList()" type="primary">查询</el-button>
                </el-form-item>
            </el-row>
        </el-form>
        <!-- 表格 -->
        <el-table ref="moviesTable" height="360" size="mini" style="width: 100%" :data="mainData" border stripe highlight-current-row :header-cell-style="getHeaderCellStyle" @row-dblclick="dblclick"
                  @selection-change="mainSelectionChange">
            <el-table-column type="selection" width="50"></el-table-column>
            <el-table-column align="center" min-width="120" prop="businessId" label="业务单号" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" min-width="120" prop="businessType" label="订单类型" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" min-width="120" prop="opmName" label="业务员名称" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" min-width="120" prop="coName" label="货主" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" min-width="120" prop="salesName" label="供货商业务员" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" min-width="120" prop="smName" label="购进单位名称" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" min-width="120" prop="totalNumber" label="总数量" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" min-width="120" prop="oldMoney" label="总金额" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" min-width="120" prop="bookkeepDate" label="记账日期" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <span v-if="scope.row.bookkeepDate">
                        {{$common.getLocalTime(scope.row.bookkeepDate)}}
                    </span>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination v-if="isPagination" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="pageSizes" background :page-size="pageSize"
                       layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
        <el-collapse v-model="activeName" accordion>
            <el-collapse-item name="1" :disabled="true">
                <template slot="title">
                    <div style="display: flex; align-items: center;justify-content: space-between;width: 100%;">
                        <div style="display: flex; align-items: center;">
                            <el-switch style="display: block" @change="showDetailChange" v-model="showdetail" active-text="展示明细" inactive-text="关闭明细">
                            </el-switch>
                            <el-button v-if="isDetail||returnObj.mainData.length>0" size="mini" @click="sureDetail" style="margin-left: 60px" type="primary">确认选择</el-button>
                            <el-tag v-else size="mini" style="margin-left: 60px">明细表格</el-tag>
                        </div>
                        <el-tag style="font-size: 16px;">总金额：￥{{totalMoney}}</el-tag>
                    </div>
                </template>
                <!-- 明细表 -->
                <el-table size="mini" height="200" :data="detailData" border stripe highlight-current-row :header-cell-style="getHeaderCellStyleD" style="width: 100%">
                    <el-table-column align="center" min-width="120" prop="businessId" label="业务单号" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column align="center" min-width="120" prop="bgmName" label="通用名称" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column align="center" min-width="100" prop="spec" label="规格" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column align="center" min-width="130" prop="manufacturer" label="生产厂商" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column align="center" min-width="120" prop="businessType" label="订单类型" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column align="center" min-width="120" prop="prodate" label="生产日期" :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            <span v-if="scope.row.prodate">
                                {{$common.getLocalTime(scope.row.prodate)}}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" min-width="120" prop="expidate" label="有效期" :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            <span v-if="scope.row.expidate">
                                {{$common.getLocalTime(scope.row.expidate)}}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" min-width="120" prop="inRate" label="进项税率" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column align="center" min-width="120" prop="price" label="单价" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column align="center" min-width="120" prop="money" label="金额" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column align="center" min-width="120" prop="psprice" label="含税价格" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column align="center" min-width="120" prop="psmoney" label="含税金额" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column align="center" min-width="120" prop="treatCount" label="待开票数量" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column align="center" min-width="120" prop="batchno" label="批号" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column align="center" min-width="120" prop="sterBatchno" label="灭菌批号" :show-overflow-tooltip="true"></el-table-column>
                </el-table>
            </el-collapse-item>
        </el-collapse>

        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :append-to-body="true">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "PurchaseInvoiceExtract",
    components: {},
    data() {
        return {
            opmId: "",
            ormId: "",
            activeName: "1",//默认展开
            showdetail: true,
            detailData: [],
            currentPage: 1,
            pageSizes: [10, 25, 50, 100],
            pageSize: 10,
            total: 0,
            mainData: [],
            selectedDataIndexList: [],
            isPagination: "",
            searchTermList: [], //检索条件
            Columns: [],
            ColumnsDetail: [],
            isDetail: false,
            multipleSelection: [], //数组内层
            returnObj: {//外层对象数据
                mainData: [],
                detailData: []
            },
            seWidth: "",
            exWidth: "",
            seTitle: "",
            DialogVisible: false,
            parentSearchData: {},
            totalMoney: 0
        };
    },

    props: {
        invoiceExtractData: {
            type: Object,
            require: true
        },
        formShow: {
            type: Boolean,
            require: true,
            default: false
        },

    },
    watch: {},
    computed: {},
    mounted() { },
    created() {
        // 处理组件需要的数据
        this.opmId = JSON.parse(sessionStorage.getItem("userInfo")).opmId
        this.getTableMainList()
    },
    methods: {
        getSeWidth(e) {
            // console.log(e);
            this.seWidth = e + "%";
        },
        getWidth(e) {
            // console.log(e);
            this.exWidth = e + "%";
        },
        getSearchName(e) {
            // console.log(e);
            this.seTitle = e;
        },
        //检索带回数据
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                if (this.seType == 'smName') this.parentSearchData.smId = val.smId
                this.paramValue(val)
            }
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.$set(this.invoiceExtractData, item, val[item])
            })
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField) {

            this.DialogVisible = true
            this.seType = type
            this.seId = sId
            this.sField = sField
            this.parentSearchData[type] = this.invoiceExtractData[type]
        },
        //明细隐藏
        showDetailChange(e) {
            e == true ? (this.activeName = "1") : (this.activeName = "0");
        },
        // 切换显示条数
        setDataPageSize(val) {
            this.invoiceExtractData.page = 1
            this.invoiceExtractData.rows = val
            this.getTableMainList()
        },

        //主单选择
        mainSelectionChange(val) {
            this.returnObj.mainData = JSON.parse(JSON.stringify(val))
            this.selectedDataIndexList = []
            val.forEach(v => {
                if (v.isDetail !== 0) {
                    this.selectedDataIndexList.push(v.dapmId)
                }
            })
            if (this.selectedDataIndexList.length > 0) {
                this.getTableDetailList()
            }
            if (this.selectedDataIndexList.length == 0) {
                this.detailData = []
            }
        },
        dblclick(row) {
            var flag = false
            this.returnObj.mainData.forEach((item, index) => {
                if (item.businessId == row.businessId && !flag) {
                    flag = true
                    this.$refs.moviesTable.toggleRowSelection(row, false)
                    this.returnObj.mainData.splice(index, 1)
                }
            })
            if (!flag) {
                this.$refs.moviesTable.toggleRowSelection(row, true)
                this.returnObj.mainData.push(row)
            }
        },
        //确认选择
        sureDetail() {
            this.returnObj.detailData = JSON.parse(JSON.stringify(this.detailData))
            this.returnObj.mainData.sort(function (a, b) {
                return b.createTime - a.createTime
            })
            if (this.returnObj.detailData.length > 0) {
                this.returnObj.detailData.sort(function (a, b) {
                    return b.createTime - a.createTime
                })
            } else {
                this.returnObj.detailData = []
            }
            this.$emit("invoiceExtractMethods", this.returnObj);
        },
        getList() {//查询
            this.invoiceExtractData.page = 1
            this.getTableMainList()
        },
        // 获取主表格
        async getTableMainList() {
            let res = await this.$http.extractPsaccountMaster(this.invoiceExtractData)
            if (res && res.status == 200) {
                this.mainData = res.result; //默认第一条
            } else {
                this.$message({
                    message: res.message,
                    type: 'error'
                });
                this.$emit("invoiceExtractMethods", '')
                return false
            }
        },
        // 获取明细表格
        async getTableDetailList() {
            let res = await this.$http.extractPsaccountDetail({ "ids": this.selectedDataIndexList })
            if (res && res.status == 200) this.detailData = res.result
            this.totalMoney = 0
            this.detailData.forEach(v => {
                this.totalMoney += v.psmoney
            })
            this.isDetail = this.detailData.length > 0 ? true : false
        },
        //分页
        handleSizeChange(val) {
            this.pageSize = val;
            this.invoiceExtractData.rows = val;
            this.getTableMainList();
        },
        // 分页
        handleCurrentChange(val) {
            this.currentPage = val;
            this.invoiceExtractData.page = val;
            this.getTableMainList();
        },
        //   -----------------------------------------------------
        getHeaderCellStyle() {
            return "background: skybule; borderBottom: solid 1px #5a5e66;color: #3e5569";
        },
        getHeaderCellStyleD() {
            return "background: skybule;color: #3e5569";
        },

    },
};
</script>

<style scoped>
.el-pagination {
    padding: 20px 0px 5px;
}
</style>
